import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFolderQuestion = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "folder-question" }),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 8.25,
			y1: 18.75,
			x2: 2.447,
			y2: 18.75
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M20.25,8.25v-3a1.5,1.5,0,0,0-1.5-1.5H8.25V2.25A1.5,1.5,0,0,0,6.75.75H2.25a1.5,1.5,0,0,0-1.5,1.5v14.8a1.7,1.7,0,0,0,3.336.438L6.437,9.334A1.5,1.5,0,0,1,7.879,8.25H21.75A1.5,1.5,0,0,1,23.2,10.136"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M11.323,16.3A6,6,0,1,0,16.3,11.323,6.006,6.006,0,0,0,11.323,16.3Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M15.375,16.125A1.875,1.875,0,1,1,17.25,18"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M17.25,20.25a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375"
		})
	]
});
export default SvgFolderQuestion;
